{
  "nl": {
    "survey": {
      "actions": {
        "add": "Voeg nieuwe toe",
        "addDescription": "Voeg omschrijving toe",
        "close": "Sluit",
        "create": "Creëer ",
        "createNew": "Nieuw",
        "delete": "Verwijderen",
        "deleteCount": "Je staat op het punt om {count} enquête te verwijderen. Ben je zeker? | Je staat op het punt om {count} enquêtes te verwijderen. Ben je zeker?",
        "deleteMultiple": "Verwijder...",
        "delete_cancel": "Annuleer",
        "delete_surveys": "Verwijder enquête | Verwijder enquêtes",
        "importTemplate": "Importeer",
        "newSurvey": "Enquête",
        "publish": "Publiceer",
        "publishCustomer": "Publiceer voor klanten",
        "revokeAccess": "Toegang intrekken",
        "save": "Opslaan",
        "selectAll": "Selecteer alle {total} enquêtes",
        "send": "Stuur",
        "sendCustomer": "Verzenden naar klant",
        "submit": "Opslaan",
        "surveys_collapse": "Sluit alle enquêtes",
        "surveys_expand": "Open alle enquêtes",
        "unSelectAll": "Wis de selectie",
        "unpublish": "Depubliceer"
      },
      "attributes": {
        "description": "Interne titel",
        "title": "Vraag"
      },
      "labels": {
        "NPSOverview": "NPS samenvatting",
        "NPSQuestion": "Hoe waarschijnlijk is het dat je {name} zal aanbevelen aan een vriend of collega?",
        "addQuestion": "Vraag",
        "allUnitsAssigned": "Alle units zijn toegewezen",
        "answerRequired": "Antwoord (verplicht)",
        "answer_later": "Later antwoorden",
        "answeredAt": "Beantwoord op",
        "average_score": "Gemiddelde score",
        "clientTeam": "Het {name} Team",
        "comments": "Opmerkingen of suggesties? (optioneel)",
        "completedTime": "Beantwoord",
        "customer": "Klant",
        "customer_status": "Status",
        "detractors": "Critici",
        "dissatisfied": "Ontevreden",
        "extremelyLikely": "Zeer waarschijnlijk",
        "lets_go": "Ok!",
        "list": "Lijst",
        "mostRecentAnswers": "Meest recente antwoorden",
        "neither_satisfied_nor_dissatisfied": "Niet tevreden maar ook niet ontevreden",
        "neutrals": "Neutrals",
        "noAnswers": "Nog geen antwoorden",
        "noSurveyFeedback": "Geen opmerkingen of suggesties",
        "noSurveysYet": "Nog geen enquêtes. Maak jouw eerste enquête om te beginnen.",
        "noUnitsClick": "Nog geen units toegevoed. Klik hier om toe te voegen",
        "no_opinion": "Geen mening",
        "notAtAllLikely": "Zeer onwaarschijnlijk",
        "nps": "NPS",
        "numberAnswered": "{answered} van de {total} antwoorden",
        "obligatory": "Maak deze enquête verplicht voor klanten",
        "pendingSurveys": "We hebben jouw feedback nodig",
        "promoters": "Promoters",
        "publishNow?": "Publiceer nu?",
        "published": "Gepubliceerd",
        "publishedCount": "Publiceer deze enquête naar de klant | Publiceer {count} enquêtes naar de klanten",
        "question": "Vraag",
        "question_number": "Vraag {current_number} van {total_questions}",
        "questions": "Vragen",
        "respondents": "Nog geen respondenten | 1 respondent | {count} respondenten",
        "response": "Antwoord",
        "responseTime": "Reactietijd",
        "responses": "Antwoorden",
        "revokeAccessCount": "Toegang tot deze enquête intrekken voor klanten | Toegang tot deze enquête intrekken voor {count} klanten",
        "satisfied": "Tevreden",
        "saveExplainer": "Maak deze enquête meteen zichtbaar voor jouw klanten? Of sla op en publiceer later?",
        "scoreBreakdown": "Scoreverdeling",
        "selectOneUnit": "Selecteer minstens één enquête",
        "selectUnits": "Selecteer units",
        "selected": "{selected} enquête is geselecteerd. | {selected} enquêtes zijn geselecteerd.",
        "sendCount": "Stuur deze enquête naar de klant | Stuur enquêtes naar {count} klanten",
        "sendExplainer": "De klant ziet dit op zijn dashboard",
        "sendNow?": "Nu verzenden?",
        "sent": "Verzonden",
        "sentCustomer": "Verzonden naar klant",
        "showSurveysFor": "Toon enquêtes voor",
        "showingResultsFor": "Toon resultaten voor",
        "step0Title": "Welk projectsjabloon en welke enquête wil je gebruiken?",
        "step2Subtitle": "Zo weten jouw klanten beter wat het doel is van deze enquête",
        "step2Title": "Voeg een korte introductie toe",
        "step3Subtitle": "Selecteer het project om al de units in één keer op te nemen.",
        "step3Title": "Voor welke units wil je deze enquête opstellen?",
        "survey": "Enquête",
        "surveyAlreadyAnswered": "Enquête is al beantwoord. Bedankt voor je feedback.",
        "surveyAnswer": "Feedback",
        "surveyNotCompleted": "Enquête is nog niet voltooid.",
        "surveys": "Enquêtes",
        "surveysCount": "{count} enquête | {count} enquêtes",
        "surveys_all_projects": "Enquêtes alle projecten",
        "tabOverview": "Overzicht",
        "tabSurveys": "Enquêtes",
        "thankYou": "Bedankt voor jouw feedback!",
        "title": "Vraag",
        "titles_must_be_unique": "Er zijn dubbele vragen. Vragen moeten uniek zijn!",
        "totalSelected": "Alle {total} enquêtes zijn geselecteerd.",
        "unanswered": "Onbeantwoord",
        "unit": "Unit",
        "unitSelected": "Geen unit geselecteerd | Eén unit geselecteerd | {count} units geselecteerd",
        "units": "Units",
        "unitsWithoutSurvey": "{count} unit zonder enquête | {count} units zonder enquête",
        "unpublishedCount": "Depubliceer deze enquête | Depubliceer {count} enquêtes",
        "very_dissatisfied": "Zeer ontevreden",
        "very_satisfied": "Erg tevreden",
        "visibility": "Visibiliteit",
        "yourAnswers": "Jouw antwoorden",
        "yourQuestion": "Jouw vraag"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Vraag je klanten om feedback",
            "title": "Maak je eerste enquête aan"
          },
          "none": {
            "subtitle": "Vraag je klanten om feedback",
            "title": "Geen enquêtes gevonden"
          }
        }
      },
      "toasts": {
        "bulk_create": "Enquête met success aangemaakt | Enquêtes met success aangemaakt",
        "bulk_delete": "Enquête met succes verwijderd | Enquêtes met succes verwijderd",
        "bulk_update": "Enquête met succes bijgewerkt | Enquêtes met success bijgewerkt",
        "update": "Enquête met succes bijgewerkt"
      },
      "validation": {
        "needName": "De naam is vereist",
        "needQuestion": "Voeg minstens 1 vraag toe",
        "selectUnit": "Selecteer ten minste 1 unit"
      }
    }
  }
}